import { render } from "./AdmUserDetail.vue?vue&type=template&id=15fad05f&scoped=true"
import script from "./AdmUserDetail.vue?vue&type=script&lang=js"
export * from "./AdmUserDetail.vue?vue&type=script&lang=js"

import "./AdmUserDetail.vue?vue&type=style&index=0&id=15fad05f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15fad05f"]])

export default __exports__